import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

@Component({
  selector: 'app-input-alert',
  templateUrl: './input-alert.component.html',
  styleUrls: ['./input-alert.component.scss']
})
export class InputAlertComponent {

  title: string = '';
  content: string = '';
  data: string = "";
  confirmButtonShowFlag: boolean = true;
  cancelButtonName: string = '关闭';
  onClose: any;

  constructor(public bsModalRef: BsModalRef) { }
  cancel() {
    this.bsModalRef.hide();
  }

  confirm() {
    this.bsModalRef.hide();
    this.onClose('confirm', this.data);

  }

}
